module.exports = __webpack_public_path__ + "static/meetup-fb281879d873feb332e5f320a4ac5b3c.jpg";